document.addEventListener('DOMContentLoaded', () => {
  new Swiper('.blog-products__items--swipper-wrap', {
      slidesPerView: 'auto',
      spaceBetween: 0,
      loop: false,
      navigation: {
      nextEl: ".article_products-button-next",
      prevEl: ".article_products-button-prev"
      },
      pagination: {
          el: ".swiper-pagination",
          clickable: true
      },
      keyboard: {
          enabled: true
      }
  });
});

$(window).on('load', function() {
    //On load TOC active element check
    var offset = 0; 
    var scrollPosition = $(window).scrollTop() + offset;
    var sectionTop = $('.article-content').offset().top;
    var currentSectionId = null;
    if(scrollPosition <= sectionTop){
      var firstItem = $('.table-of-content__item:nth-child(1)');
      if (firstItem.length) {
        firstItem.addClass('active');
      }
    } else {
      $('.article-content-main > div[id]').each(function () {
          var elementTop = $(this).offset().top;
          if (scrollPosition >= elementTop) {
            currentSectionId = $(this).attr('id');
          }
      });
      if (currentSectionId) {
        $('.table-of-content__item').removeClass('active');
        $('.table-of-content__link[data-link="' + currentSectionId + '"]').closest('li').addClass('active');
      }
    }

     //On load TOC mobile hide/display check
    var articleImageTop = $('.article__image').offset().top;
    if(scrollPosition >= articleImageTop ){
        $('.table-of-content-mobile').slideDown(300);
    } else {
        $('.table-of-content-mobile').slideUp(300);
    }

    //TOC on click scroll to section
    $('.table-of-content__link').on('click', function(e){
        var headerHeight = $('.header').height();
        var mobileTocheight = $('.table-of-content-mobile-title').height();
        let activeID = $(this).attr('data-link');
        let scrollToSection = $('.article-content-main div[id="' + activeID + '"]');
        let scrollTop = $(window).scrollTop(); 
        let targetTop = 0;
        if (window.innerWidth >= 910) {
            if (scrollTop > $(scrollToSection).offset().top) {
                targetTop = $(scrollToSection).offset().top - headerHeight - 20;
            } else {
                targetTop = $(scrollToSection).offset().top - 20;
            }
        } else {
           if (scrollTop > $(scrollToSection).offset().top) {
                targetTop = $(scrollToSection).offset().top - headerHeight - mobileTocheight - 40;
            } else {
                targetTop = $(scrollToSection).offset().top - mobileTocheight - 40;
            }
          $('.table-of-content-mobile-title').trigger('click');
        }
        window._tocScrolling = true;
        window._tocScrollDown = targetTop > $(window).scrollTop();
        $('html, body').animate({ scrollTop: targetTop }, 300, function() {
            window._tocScrolling = false;
        });
    });

     //TOC mobile on click scroll to section
    $('.table-of-content-mobile-title').on('click',function(){
        let container = $(this).closest('.table-of-content-mobile');
        if(container.hasClass('active')){
            container.removeClass('active');
            container.find('.table-of-content-mobile__list').slideUp(300);
        } else {
            container.addClass('active');
            container.find('.table-of-content-mobile__list').slideDown(300);
        }
    });
});

// Code from blog-products.liquid adapt
document.addEventListener('DOMContentLoaded', () => {
    const productCarts = document.querySelectorAll('.blog-products__items--swipper-wrap .product_cart');
    productCarts.forEach((productCart) => {
      productCart.querySelectorAll('input[type="radio"].variant-input').forEach((input) => {
        input.addEventListener('change', function () {
          if (this.checked) {
            let productImage = productCart.querySelector('#product_cart_image');
            let currentSrc = productImage.src;
            let currentSrcset = productImage.srcset;
            let cdnIndex = currentSrc.indexOf('shop/');

            if (cdnIndex !== -1) {
              let updatedSrc = currentSrc.substring(0, cdnIndex + 5) + this.dataset.image;
              let updatedSrcset = currentSrcset.replace(/(shop\/)[^ ]+/g, `shop/${this.dataset.image}`);

              productImage.srcset = updatedSrcset;
              productImage.src = updatedSrc;
            }
          }
        });
      });

      productCart.querySelectorAll('.variant__label').forEach((label) => {
        label.addEventListener('mouseenter', () => {
          const radioId = label.getAttribute('data-radio-id');
          const radioButton = productCart.querySelector(`#${radioId}`);
          radioButton.checked = true;

          // Track which color is actively hovered so type hover can use it
          if (radioButton.dataset.color) {
            productCart.dataset.activeColor = radioButton.dataset.color;
          }

          let typeInput = [
            ...document.querySelectorAll(
              `.product_cart__variants.types .variant.color input[data-color="${radioButton.dataset.color}"]`
            ),
          ].find((el) => el.name !== radioButton.name);
          typeInput ? (typeInput.checked = true) : '';

          let productImage = productCart.querySelector('#product_cart_image');
          let currentSrc = productImage.src;
          let currentSrcset = productImage.srcset;
          let cdnIndex = currentSrc.indexOf('shop/');

          if (cdnIndex !== -1) {
            let updatedSrc = currentSrc.substring(0, cdnIndex + 5) + radioButton.dataset.image;
            let updatedSrcset = currentSrcset.replace(/(shop\/)[^ ]+/g, `shop/${radioButton.dataset.image}`);

            productImage.srcset = updatedSrcset;
            productImage.src = updatedSrc;
          }
        });
      });
      // types

      productCart.querySelectorAll('input[type="radio"].type-input').forEach((input) => {
        input.addEventListener('change', function () {
          if (this.checked) {
            let colors = productCart.querySelectorAll('.variant.color');
            colors.forEach((color) => {
              this.dataset.name === color.dataset.name
                ? (color.style.display = 'block')
                : (color.style.display = 'none');
            });
            const activeColor = productCart.dataset.activeColor;
            let checkedInput = activeColor
              ? productCart.querySelector(`.variant.color[data-name="${this.dataset.name}"] input[type="radio"][data-color="${activeColor}"]`)
              : null;
            if (!checkedInput) {
              checkedInput = productCart.querySelector(`.variant.color[data-name="${this.dataset.name}"] input[type="radio"]:checked`);
            }
            changeImage(productCart, checkedInput.dataset.image);
          }
        });
      });

      productCart.querySelectorAll('.type__label').forEach((label) => {
        label.addEventListener('mouseenter', () => {
          const radioId = label.getAttribute('data-radio-id');
          const radioButton = productCart.querySelector(`#${radioId}`);
          radioButton.checked = true;

          let colors = productCart.querySelectorAll('.variant.color');
          colors.forEach((color) => {
            radioButton.dataset.name === color.dataset.name
              ? (color.style.display = 'block')
              : (color.style.display = 'none');
          });

          // Use the last hovered color; fall back to whichever color is :checked
          const activeColor = productCart.dataset.activeColor;
          let checkedInput = activeColor
            ? productCart.querySelector(`.variant.color[data-name="${radioButton.dataset.name}"] input[type="radio"][data-color="${activeColor}"]`)
            : null;
          if (!checkedInput) {
            checkedInput = productCart.querySelector(`.variant.color[data-name="${radioButton.dataset.name}"] input[type="radio"]:checked`);
          }
          changeImage(productCart, checkedInput.dataset.image);
        });
      });

      productCart.querySelectorAll('.product_cart__image-block').forEach((block) => {
        block.addEventListener('mouseenter', function () {
          const video = block.querySelector('.hovered-content video');
          if (video) {
            video.play();
          }
        });

        block.addEventListener('touchstart', function () {
          const video = block.querySelector('.hovered-content video');
          if (video) {
            video.play();
          }
        });

        block.addEventListener('mouseleave', function () {
          const video = block.querySelector('.hovered-content video');
          if (video) {
            video.pause();
            video.currentTime = 0;
          }
        });

        block.addEventListener('touchend', function () {
          const video = block.querySelector('.hovered-content video');
          if (video) {
            video.pause();
            video.currentTime = 0;
          }
        });
      });
    });

    function changeImage(productCart, imageSrc) {
      let productImage = productCart.querySelector('#product_cart_image');
      let currentSrc = productImage.src;
      let currentSrcset = productImage.srcset;
      let cdnIndex = currentSrc.indexOf('shop/');

      if (cdnIndex !== -1) {
        let updatedSrc = currentSrc.substring(0, cdnIndex + 5) + imageSrc;
        let updatedSrcset = currentSrcset.replace(/(shop\/)[^ ]+/g, `shop/${imageSrc}`);

        productImage.srcset = updatedSrcset;
        productImage.src = updatedSrc;
      }
    }
  });